import bbitApi from '@api/make-request'

export function getAllRoles(source?) {
  return bbitApi.get('api/v1/roles', { cancelToken: source?.token })
}
